export default __webpack_public_path__ + "static/media/zertiassist_iconos_certificates_24px.f6d41a28.svg";